import React, { useContext } from "react";
import { LoadingContext } from "../../../../context/spinnerContext";
import { CircularProgress } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const loadingStyles = makeStyles({
  wrapper: {
    width: "100%",
    height: "100%",
    position: "fixed",
    top: "0",
    left: "0",
    right: "0",
    bottom: "0",
    backgroundColor: "rgba(0,0,0,0.5)",
    zIndex: "2",
  },
  spinner: {
    position: "absolute",
    top: "50%",
    left: "50%",
  },
});

const BackdropLoading = () => {
  const { isLoading } = useContext(LoadingContext);
  const classes = loadingStyles();
  return (
    <>
    {isLoading && (<div
      className={classes.wrapper}
    >
      <CircularProgress
        size={50}
        className={classes.spinner}
      />
    </div>)}
    </>
  )
};
export default BackdropLoading;
